var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['status-chip', 'is-' + _vm.type]},[(_vm.icon)?_c('i',{class:['fas', _vm.icon, 'mr-1']}):_vm._e(),_vm._v(_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }